<template>
  <v-dialog v-model="aberto" max-width="80%" max-height="70%" scrollable>
    <v-card class="pa-4">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h6">{{ titulo }}</span>
        <v-btn icon @click="fechar" variant="text">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-0">
        <v-text-field
          v-model="search"
          label="Pesquisar"
          prepend-icon="mdi-magnify"
          class="mx-4 my-3 mt-6"
          dense
          hide-details
        />
        <v-data-table
          :item-key="itemKey"
          :headers="headers"
          :items="dados"
          :items-per-page="5"
          :search="search"
          :footer-props="{
            itemsPerPageText: 'Linhas por página:',
            itemsPerPageAllText: 'Todas',
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
          :page.sync="pagina"
          class="elevation-0"
          :loading="loading"
          loading-text="Carregando... Aguarde"
          density="comfortable"
          fixed-header
          height="400px"
        >
          <template v-slot:[`item.academia`]="{ item }">
            <v-badge
              :color="
                item.academia_id
                  ? item.academia_id == 1
                    ? 'rgb(242, 128, 166)'
                    : 'rgb(96, 204, 240)'
                  : 'green'
              "
              style="color: black"
              :content="item.academia"
            ></v-badge>
          </template>

          <template v-slot:[`item.situacao_contrato`]="{ item }">
            <v-badge
              :color="
                item.situacao_contrato
                  ? item.situacao_contrato?.trim() === 'Rescisão'
                    ? 'red'
                    : 'orange'
                  : ''
              "
              style="color: black"
              :content="item.situacao_contrato"
            ></v-badge>
          </template>

          <template v-slot:[`item.aluno_id`]="{ item }">
            <v-btn @click="goToPersonalData(item.aluno_id)" text>
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.data_inicial`]="{ item }">
            {{ item.data_inicial_formatada }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <AppVamoMexe :value="item.status" />
          </template>
          <template v-slot:[`item.data_final`]="{ item }">
            {{ item.data_final_formatada }}
          </template>

          <template v-slot:[`item.usuario_id`]="{ item }">
            <v-btn @click="goToPersonalData(item.usuario_id, item.aluno, true)" text>
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.produto`]="{ item }">
            <AppProduto :value="item.produto" />
          </template>

          <template v-slot:[`item.tipo`]="{ item }">
            <AppHistorico :value="item.tipo" />
          </template>

          <template v-slot:[`item.motivo`]="{ item }">
            {{ getText(item.motivo) }}
          </template>

          <template v-slot:[`item.motivo_saida`]="{ item }">
            {{ getText(item.motivo_saida, true) }}
          </template>
          <!-- <template #footer="{ pageStart, pageStop, itemsLength }"> -->
          <!-- <div class="text-caption text-end pa-2"> -->
          <!-- {{ pageStart }}-{{ pageStop }} de {{ itemsLength }} itens -->
          <!-- </div> -->
          <!-- </template> -->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import AppProduto from '@/components/AppProduto.vue';
import AppHistorico from '@/components/AppHistorico.vue';
import motivos from '@/models/tipo-motivo-transferencia.js';
import saida_motivos from '@/models/tipo-motivo-saida.js';
import AppVamoMexe from '@/components/AppVamoMexe.vue';

export default {
  components: { AppProduto, AppHistorico, AppVamoMexe },
  name: 'ModalLista',
  props: {
    value: Boolean, // v-model
    titulo: {
      type: String,
      default: 'Lista',
    },
    dados: {
      type: Array,
      required: true,
    },
    itemKey: {
      type: String,
      default: 'aluno_id',
    },
    headers: {
      type: Array,
      required: true, // Ex: [{ text: 'Nome', value: 'nome' }]
    },
    porPagina: {
      type: Number,
      default: 10,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pagina: 1,
      search: '',
    };
  },
  watch: {
    dados() {
      this.pagina = 1;
    },
  },
  computed: {
    aberto: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    getText(value, isUser = false) {
      if (isUser) return value ? saida_motivos[value - 1].text : '-';
      return value ? motivos[value - 1].text : '-';
    },
    goToPersonalData(id, nome = null, isUSer = false) {
      if (isUSer) return this.$router.push(`/usuario/${id}/aluno/${nome}/dados-pessoais`);
      return this.$router.push(`/aluno/${id}/dados-pessoais`);
    },
    fechar() {
      this.aberto = false;
    },
    trocarPagina(val) {
      this.pagina = val;
    },
  },
};
</script>
